const PILOT_BASE_ROUTE = "/parkhyattphuquoc/homepage/";

/** Base route of the PHPQ landing page when it explicitly opts in to the pilot. */
function pilotBaseRoute(): string | null {
  const embedding = document.querySelector<HTMLElement>(
    '#app[data-gep-pwa="true"]',
  );
  const baseRoute = embedding?.getAttribute("base-route");
  if (baseRoute !== PILOT_BASE_ROUTE) return null;
  if (
    location.pathname !== baseRoute.slice(0, -1) &&
    !location.pathname.startsWith(baseRoute)
  )
    return null;
  return baseRoute;
}

/** True only on the PHPQ landing page that explicitly opts in to the pilot. */
export function isGepPwaPage(): boolean {
  return pilotBaseRoute() !== null;
}

/**
 * Whether guests may be offered the install / shortcut prompt. Same pilot gate
 * as the service worker, plus a dev-only override so the banner can be checked
 * locally without the PHPQ host page.
 */
export function isGepPwaInstallPromptEnabled(): boolean {
  if (import.meta.env.DEV && import.meta.env.VITE_GEP_PWA_INSTALL === "true")
    return true;
  return isGepPwaPage();
}

/** Register only the PHPQ landing page that explicitly opts in to the pilot. */
export function registerGepPwa(): void {
  if (!("serviceWorker" in navigator)) return;
  const baseRoute = pilotBaseRoute();
  if (!baseRoute) return;
  void navigator.serviceWorker
    .register(`${baseRoute}sw.js`, { scope: baseRoute })
    .catch((error) => console.warn("GEP offline support unavailable", error));
}
